var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4a1 1 0 00-1 1v14a1 1 0 001 1h18a1 1 0 001-1V5a1 1 0 00-1-1H3zm1 3.045V17a1 1 0 001 1h14a1 1 0 001-1V7.045l-7.386 5.744a1 1 0 01-1.228 0L4 7.045zM18.085 6H5.915l5.471 4.256a1 1 0 001.228 0L18.085 6z"
  })));
}
export default __webpack_public_path__ + "152ff6c2f1479b06ef75a45fe681ca46.svg";
export { SvgMail as ReactComponent };